module.exports = __webpack_public_path__ + "img/benefits01-04.00de485.png";